import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { NitroLoading } from 'nitro-components';

import * as pbi from 'powerbi-client';
import isEqual from 'lodash/isEqual';

import {
  getInsightsCCAndCountry,
  getRestrictionFilter,
} from '../../powerbi/selector';

import PowerBIApi from '../../../api/PowerBIApi';
import ApiActions from '@src/action/ActionFactory';
import { parsePBIMeta, getPBIContextFilter } from '@src/utils/helpers/powerbi';

const BIHolder = styled.div`
  position: relative;
  margin-top: ${props => (props.isLoading ? '120px' : 0)};
  height: 100%;

  && iframe {
    border: none;
  }
`;

const Overlay = styled.div`
  position: absolute;
  z-index: 200;
  width: 100%;
  height: 100%;
`;

class InsightPowerBI extends PureComponent {
  state = {
    isLoading: true,
  };

  componentDidUpdate(prevProps, prevState) { }

  componentDidUpdate(prevProps) {
    const { costcenter, restrictions } = this.props;
    const { costcenter: prevCC, restrictions: prevRestrictions } = prevProps;

    if (
      !isEqual(costcenter, prevCC) ||
      !isEqual(restrictions, prevRestrictions)
    ) {
      this.loadEmbed();
    }
  }

  componentDidMount() {
    this.loadEmbed();
  }

  getContent(id) {
    return this.props.apiActions
      .get({
        resource: 'CONTENT',
        id: id,
      })
      .then(data => {
        return data;
      });
  }

  async loadEmbed() {
    const { id, country, costcenter, restrictions } = this.props;

    const contentRes = await this.getContent(id);
    const conf = contentRes[0];

    const pbiMeta = parsePBIMeta(conf.metadata);
    if (!pbiMeta) return;

    const defaultVisuals = {
      x: 0,
      y: 0,
      z: 0,
      width: 234,
      height: 234,
      displayState: {
        mode: pbi.models.VisualContainerDisplayMode.Visible,
      },
    };

    PowerBIApi.getReportEmbedConfig(
      country.value,
      costcenter.value,
      pbiMeta.refId
    ).then(conf => {
      const visualConf = {};
      if (pbiMeta.visuals) {
        for (var key in pbiMeta.visuals) {
          visualConf[key] = Object.assign(
            {},
            defaultVisuals,
            pbiMeta.visuals[key]
          );
        }
      }

      conf.filters = getPBIContextFilter(conf.company, restrictions, conf.restrictions);
      conf.pageName = pbiMeta.pageName;
      conf.settings = {
        filterPaneEnabled: false,
        navContentPaneEnabled: false,
        layoutType: pbi.models.LayoutType.Custom,
        customLayout: {
          pageSize: {
            type: pbi.models.PageSizeType.Custom,
            width: 234,
            height: 234,
          },
          displayOption: pbi.models.DisplayOption.FitToPage,
          pagesLayout: {
            [pbiMeta.pageName]: {
              defaultLayout: {
                displayState: {
                  mode: pbi.models.VisualContainerDisplayMode.Hidden,
                },
              },
              visualsLayout: visualConf,
            },
          },
        },
      };
      window.powerbi.reset(this.embedNode);
      window.powerbi.embed(this.embedNode, conf);

      this.setLoading(false);
    });
  }

  setLoading = sts => {
    this.setState({
      isLoading: sts,
    });
  };

  render() {
    const { isLoading } = this.state;
    return (
      <BIHolder isLoading={isLoading}>
        <Overlay />
        {isLoading && <NitroLoading center />}
        <div ref={node => (this.embedNode = node)} />
      </BIHolder>
    );
  }
}

const mapStateToProps = state => {
  const { costcenter, country } = getInsightsCCAndCountry(state);
  const { restrictions } = getRestrictionFilter(state);

  return {
    country,
    costcenter,
    restrictions,
  };
};

const mapDispatchToProps = dispatch => ({
  apiActions: bindActionCreators(ApiActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InsightPowerBI);



// WEBPACK FOOTER //
// ./src/features/insights/components/InsightPowerBI.js